import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { useCustomer } from 'msp-integrations'
import Input from '@atoms/Input/Input'
import { Button } from '@atoms/Button'
import Icons from '@atoms/Icons/Icons'

interface RequestPasswordFormProps {
  className?: string
  onSubmit?: () => void
  onClose?: () => void
}

const RequestPasswordForm = ({
  className,
  onSubmit,
  onClose
}: RequestPasswordFormProps) => {
  const { formatMessage } = useIntl()
  const customer = useCustomer()

  const [email, setEmail] = useState('')
  const [error, setError] = useState<string>('')
  const [isSending, setIsSending] = useState(false)

  const texts = {
    required: formatMessage({
      defaultMessage: 'Required',
      id: 'global.required'
    }),
    email: formatMessage({
      defaultMessage: 'Email Address',
      id: 'global.EmailAddress'
    }),
    cancel: formatMessage({
      defaultMessage: 'Cancel',
      id: 'global.cancel'
    }),
    send: formatMessage({
      defaultMessage: 'Send',
      id: 'global.send'
    })
  }

  const requestPassword = async (e?: any) => {
    e && e.preventDefault()
    if (!email.length) {
      return setError(texts.required)
    }
    setIsSending(true)
    setError('')
    try {
      const response = await customer.sendPasswordResetEmail(email)
      response.isError
        ? setError(response.arguments.statusMessage || response.message)
        : onSubmit && onSubmit()
    } catch (e) {
      setError(e.message)
    }
    setIsSending(false)
  }

  return (
    <form
      className={`ResetPasswordForm flex flex-col ${className}`}
      onSubmit={requestPassword}
      noValidate
    >
      <Input
        type='email'
        labelText={texts.email}
        onChange={(e) => setEmail(e.target.value)}
        hasError={!!error}
        errorMessage={error}
      />

      <div className='my-3 flex flex-row'>
        <Button
          variant='outline'
          className='mr-1 !w-6/12'
          onClick={() => onClose && onClose()}
        >
          {texts.cancel}
        </Button>
        <Button className='ml-1 !w-6/12' isSubmit={true} isLoading={isSending}>
          <span className='pr-2'>{texts.send}</span>
          <Icons color='white' iconName='ArrowRightStick' size='base' />
        </Button>
      </div>
    </form>
  )
}

export default RequestPasswordForm
